import { isGroupCreative } from '../utils';

export default function BuilderHeaderController(
  $location,
  $state,
  $q,
  CreativeService,
  CreativeGroupService,
  CreativeFormValidationService,
  CurrentUserService,
  CurrentPartnerService,
  SaveCreativeService,
  SettingsService,
  VideoService
) {
  const vm = this;
  vm.creativeService = CreativeService;
  vm.creativeGroupService = CreativeGroupService;
  vm.disableSave = disableSave;
  vm.handleBackClicked = handleBackClicked;
  vm.userSignedIn = false;
  vm.save = save;
  vm.confirmCancel = false;
  vm.tooltipText = tooltipText;
  vm.checkForValidations = checkForValidations;
  vm.subnavHeading = subnavHeading;
  vm.settingsService = SettingsService;

  CurrentUserService.get().then(user => {
    vm.userSignedIn = !!user;
  });

  CurrentPartnerService.get().then(({ partnerType }) => {
    vm.isDspPartner = partnerType === 'DSP';
  });

  function subnavHeading() {
    return (
      SettingsService.subnavHeading ||
      vm.creativeService.adType(vm.creativeService.creative) ||
      'Back'
    );
  }

  function formIsValid() {
    if (!vm.isDspPartner) {
      return true;
    }

    if (isGroupCreative(CreativeService.creative)) {
      return CreativeFormValidationService.groupIsValid(
        CreativeGroupService.group
      );
    } else {
      return CreativeFormValidationService.isValid(CreativeService.creative);
    }
  }

  function checkForValidations() {
    if (!formIsValid()) {
      CreativeFormValidationService.showErrors();
    }
  }

  function disableSave() {
    if (!formIsValid()) {
      return true;
    }

    // video is "always "ready" for non video creatives.
    if (!VideoService.ready()) {
      return true;
    }

    if (SettingsService.disableBuilderHeaderSave) {
      return true;
    }

    if (privateTokenMatch()) {
      return false;
    }

    return !vm.userSignedIn;
  }

  function tooltipText() {
    if (!vm.userSignedIn) {
      return 'Please login to save your Creative.';
    } else if (
      vm.isDspPartner &&
      !CreativeFormValidationService.isValid(CreativeService.creative)
    ) {
      return 'Please fill out all required fields';
    } else if (SettingsService.disableBuilderHeaderSave) {
      return '';
    }

    return 'Please wait for your video to finish processing';
  }

  function handleBackClicked() {
    SettingsService.reset();

    if (CreativeService.creative.id) {
      window.history.back();
      CreativeService.resetCreative();
      // $state.go('creativePreview.home');
    } else {
      CreativeService.resetCreative();
      $state.go('creativePreview.new');
    }
  }

  function privateTokenMatch() {
    const editToken = $location.search()['edit-token'];

    if (!editToken) {
      return false;
    }

    return editToken === CreativeService.creative.privateKey;
  }

  function save() {
    if (disableSave()) {
      return;
    }

    CreativeFormValidationService.submitted = true;

    return SaveCreativeService.save(CreativeService.creative)
      .then(() => {
        SettingsService.reset();
        $state.go('creativePreview.saved', { id: CreativeService.creative.id });
      })
      .catch(error => console.error(error)); // eslint-disable-line no-console
  }

  return vm;
}

BuilderHeaderController.$inject = [
  '$location',
  '$state',
  '$q',
  'CreativeService',
  'CreativeGroupService',
  'CreativeFormValidationService',
  'CurrentUserService',
  'CurrentPartnerService',
  'SaveCreativeService',
  'SettingsService',
  'VideoService'
];
